import CatEventTable from 'components/features/cat-event-table';
import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';

function CatEventRecords() {
  const { t } = useTranslation();

  return (
    <HomeLayout title={t('catEvent.catEventRecords')}>
      <CatEventTable />
    </HomeLayout>
  );
}

export default CatEventRecords;
